import { Component, OnDestroy, OnInit } from '@angular/core';
// tslint:disable-next-line: max-line-length
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService } from '@nebular/theme';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { interval, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RestService } from '../../../rest.service';
import { NbToastrService } from '@nebular/theme';
import { SessionTimeOutComponent } from '../session-time-out/session-time-out.component';
import { FinanceCalculatorComponent } from '../../../finance-calculator/finance-calculator.component';
import { StateScreenComponent } from '../../../state-screen/state-screen.component';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  search: any;
  name: string;
  roleName: string;
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];
  currentTheme = 'default';
  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  tokenId: number;
  employeeId: string;
  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService, private route: Router, private restService: RestService,
    private toastrService: NbToastrService, private dialogService: NbDialogService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.name = localStorage.getItem('name');
    this.roleName = localStorage.getItem('roleName');
    this.employeeId = localStorage.getItem('employeeId');
    this.netAvailable();
    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);
    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
    this.menuService.onItemClick().subscribe((event) => {
      if (event.item.title === 'Log out') {
        // tslint:disable-next-line: radix
        this.tokenId = parseInt(localStorage.getItem('tokenId'));
        this.restService.model('UpdateLogInStatus/' + this.tokenId + '/' + 0 + '/' + 1).subscribe((response) => {
          if (response.status) {
            localStorage.clear();
            if (this.showToast('Logged Out Successfully', 'primary')) {
              setTimeout(() => {
                this.route.navigate(['/auth/login']);
              }, 1000);
            }
          }
        });
      } else if (event.item.title === 'Profile') {
        // tslint:disable-next-line: radix
        this.route.navigate(['pages/profile/' + parseInt(this.employeeId)]);
      }
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // this.mySub.unsubscribe();
  }
  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }
  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }
  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  showToast(content, status) {
    // tslint:disable-next-line: max-line-length
    this.toastrService.show('', content, { limit: 1, icon: 'arrow-circle-left-outline', preventDuplicates: true, status });
    return true;
  }



  mySub: Subscription;
  // netAvailable() {
  //   let isOnline = true;

  //   this.mySub = interval(100).subscribe((() => {
  //     if (!isOnline && navigator.onLine) {
  //       isOnline = true;
  //       this.showToast('Back to Online', 'primary');
  //       
  //     } else if (isOnline && !navigator.onLine) {
  //       isOnline = false;
  //       
  //       this.dialogService.open(SessionTimeOutComponent, {
  //         hasBackdrop: true,
  //         closeOnBackdropClick: false,
  //         hasScroll: true,
  //         // tslint:disable-next-line: no-console
  //       });
  //     }
  //   }));
  // }

  netAvailable() {
    let isOnline = true;
    setInterval(function () {
      if (!isOnline && navigator.onLine) {
        isOnline = true;


      }
      else if (isOnline && !navigator.onLine) {
        isOnline = false;

      }
    }, 100);
    if (!navigator.onLine) {
      this.dialogService.open(SessionTimeOutComponent, {
        hasBackdrop: true,
        closeOnBackdropClick: false,
        hasScroll: true,
        // tslint:disable-next-line: no-console
      });
    }
  }

  financeCalculatorModal() {
    this.dialogService.open(FinanceCalculatorComponent, {
      hasBackdrop: true,
      closeOnBackdropClick: false,
      hasScroll: true,
      // tslint:disable-next-line: no-console
    });
  }


  openStateWiseRateEdition() {
    const moduleObject = { state: 'AL', appType: 'RESTD', rateFillingId: 1, effectiveDate: new Date(),globalHeaderAccess:true };
    this.dialogService.open(StateScreenComponent, {
      context: {
        inputObject: moduleObject,
      },
      hasBackdrop: true,
      closeOnBackdropClick: false,
      hasScroll: true,
      // tslint:disable-next-line: no-console
    });
  }
}







